import { useMemo, useState } from 'react'
import * as Resumo from '../../../../../../services/api/https/picking/resumo-separcao.http'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE_MISSINGS: 'Salvando faltas',
  FILE_UPLOADED: 'Foto anexada',
}

const INITIAL_STATE = {
  items: [],
  faltas: [],
  itemSelected: {},
  globalFilter: '',
  btnSalvarDisabled: false,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  selectedPicking: '',
  selectedEntrega: '',
  modal: { show: false, data: {} },
}

export default function useModalApontamentoFaltaManual() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      //Events
      onInit(data, selectedPicking) {
        setState(prevState => ({
          ...prevState,
          items: data.items,
          selectedPicking,
          selectedEntrega: data.selectedEntrega,
        }))
      },

      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      onDropdownChange(item, value) {
        setState(prevState => {
          const index = prevState.items.findIndex(i => i.delivery_item_id === item.delivery_item_id)
          if (index !== -1) {
            prevState.items[index].missing_reason = value
          }
          return { ...prevState }
        })
      },

      onUploadCompleted(file_names, item) {
        setState(prevState => {
          const index = prevState.items.findIndex(i => i.delivery_item_id === item.delivery_item_id)
          if (index !== -1) {
            prevState.items[index].files = [
              ...prevState.items[index].files.map(f => f.url_image),
              ...JSON.parse(file_names),
            ]
          }
          prevState.loadingMessage = LOAD_MESSAGE.FILE_UPLOADED

          return { ...prevState }
        })
      },

      onBtnSalvarClicked(items, selectedPicking) {
        let hasError = false
        if (selectedPicking.status === 'Resumo Emitido')
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Alteração não Permitida. Resumo já Emitido',
          }))
        else {
          const faltas = []
          items.forEach(i => {
            const { missing_reason, qte_missing_produto, delivery_item_id, qte_sku, files } = i
            if (typeof missing_reason === 'object' && typeof qte_missing_produto !== 'number') {
              hasError = true
              setState(prevState => ({
                ...prevState,
                errorMessage: `Digite a quantidade de Falta para o Produto ${i.product_code}. Operação Cancelada`,
              }))
            } else if (
              typeof missing_reason !== 'object' &&
              typeof qte_missing_produto === 'number'
            ) {
              hasError = true
              setState(prevState => ({
                ...prevState,
                errorMessage: `Selecione a Ocorrência do Produto ${i.product_code}. Operação Cancelada`,
              }))
            } else if (qte_missing_produto > qte_sku) {
              hasError = true
              setState(prevState => ({
                ...prevState,
                errorMessage: `O número de faltas não pode exceder o total de produtos. Verifique o produto de código: ${i.product_code}`,
              }))
            } else {
              let saveFiles = []
              if (files.length && typeof files[0] !== 'string') {
                saveFiles = files.map(f => f.url_image)
              } else saveFiles = files

              faltas.push({
                delivery_item_id,
                picking_id: selectedPicking.id,
                missing_reason_id: missing_reason.id,
                stage: 'Separacao',
                qte_missing: qte_missing_produto * -1,
                files: saveFiles,
              })
            }
          })

          if (!hasError) {
            setState(prevState => ({
              ...prevState,
              faltas: faltas,
              loadingMessage: LOAD_MESSAGE.SAVE_MISSINGS,
            }))
          }
        }
      },

      onFaltaInputChange(item, value) {
        setState(prevState => {
          const index = prevState.items.findIndex(i => i.delivery_item_id === item.delivery_item_id)
          if (index !== -1) {
            const qte = Number(value)
            if (qte < 0) prevState.errorMessage = 'A quantidade de falta deve ser positiva'
            else if (qte === 0) {
              prevState.items[index].missing_reason = ''
              prevState.items[index].qte_missing_produto = ''
            } else {
              prevState.items[index].qte_missing_produto = Number(value)
            }
          }
          return { ...prevState }
        })
      },

      onVerFotosClicked(missing_product, item) {
        setState(prevState => ({
          ...prevState,
          modal: { show: true, data: { fotos: missing_product.files } },
          itemSelected: missing_product,
        }))
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, modal: { show: false, data: {} } }))
      },

      async onDeleteFoto(foto, selectedPicking) {
        try {
          await Promise.all([
            Resumo.deleteMissingProductImage(selectedPicking.id, foto.id),
            Resumo.deleteMissingProductFile(foto.url_image),
          ])

          setState(prevState => {
            const index = prevState.items.findIndex(
              i => i.delivery_item_id === prevState.itemSelected.delivery_item_id,
            )
            if (index !== -1) {
              prevState.items[index].files = prevState.items[index].files.filter(
                f => f.id !== foto.id,
              )
            }
            return { ...prevState }
          })
        } catch (error) {
          setState(prevState => ({ ...prevState, errorMessage: error.message }))
        }
      },
    }
  }, [])

  return { state, localDispatch }
}
